<template>
    <div class="insulaSchemeSet">
       <el-form ref="form" label-width="140px" class="attr_common" label-position="left" :inline="true">
            <el-form-item label="保温层数:">
                <el-select v-model="insulaNumber" placeholder="请选择" class="input-box" :disabled="!updateFlag">
                    <el-option label="1层保温" :value="1"></el-option>
                    <el-option label="2层保温" :value="2"></el-option>
                    <el-option label="3层保温" :value="3"></el-option>
                    <el-option label="4层保温" :value="4"></el-option>
                </el-select>
            </el-form-item>
        </el-form>

         <el-form ref="form" label-width="140px" class="attr_common" label-position="left" :inline="true">
            <el-form-item label="第一层保温材料:">
                <el-select  v-model="curSuggestion.insulaTypeId1" placeholder="保温方案" :disabled="!updateFlag">
                    <el-option
                        v-for="item in materials"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="第一层保温厚度:">
                <el-input v-model="curSuggestion.insulaThick1" class="input-box" :disabled="!updateFlag"></el-input>
                <span class="attr_unit">mm</span>
            </el-form-item>
            <el-form-item label="第二层保温材料:" v-if="insulaNumber>=2">
                <el-select  v-model="curSuggestion.insulaTypeId2" placeholder="保温方案" :disabled="!updateFlag">
                    <el-option
                        v-for="item in materials"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="第二层保温厚度:" v-if="insulaNumber>=2">
                <el-input v-model="curSuggestion.insulaThick2" class="input-box" :disabled="!updateFlag"></el-input>
                <span class="attr_unit">mm</span>
            </el-form-item>
            <el-form-item label="第三层保温材料:" v-if="insulaNumber>=3">
                <el-select  v-model="curSuggestion.insulaTypeId3" placeholder="保温方案" :disabled="!updateFlag">
                    <el-option
                        v-for="item in materials"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="第三层保温厚度:" v-if="insulaNumber>=3">
                <el-input v-model="curSuggestion.insulaThick3" class="input-box" :disabled="!updateFlag"></el-input>
                <span class="attr_unit">mm</span>
            </el-form-item>
            <el-form-item label="第四层保温材料:" v-if="insulaNumber>=4">
                <el-select  v-model="curSuggestion.insulaTypeId4" placeholder="保温方案" :disabled="!updateFlag">
                    <el-option
                        v-for="item in materials"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="第四层保温厚度:" v-if="insulaNumber>=4">
                <el-input v-model="curSuggestion.insulaThick4" class="input-box" :disabled="!updateFlag"></el-input>
                <span class="attr_unit">mm</span>
            </el-form-item>
        </el-form>


        <!--保温方案设置-->
        <el-table
            :data="suggestions"
            border
            style="width: 100%"
            class="custom-table"
            max-height="300"
            highlight-current-row
            row-class-name="custom-row"
            cell-class-name="custom-cell"
            header-row-class-name="custom-header"
            @current-change="suggestionChange"
            ref="suggestionsTable">

            <el-table-column
                prop="id"
                width="50"
                label="编号">
            </el-table-column>
            <el-table-column
                prop="insulaNum"
                label="保温层数">
            </el-table-column>
            <el-table-column
                label="保温材料1">
                 <template slot-scope="scope">
                    <span>{{materials[scope.row.insulaTypeId1].name}}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="insulaThick1"
                label="保温厚度1">
            </el-table-column>
            <el-table-column
                label="保温材料2">
                <template slot-scope="scope">
                    <span>{{materials[scope.row.insulaTypeId2]?materials[scope.row.insulaTypeId2].name:''}}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="insulaThick2"
                label="保温厚度2">
            </el-table-column>
            <el-table-column
                label="保温材料3">
                <template slot-scope="scope">
                   <span>{{materials[scope.row.insulaTypeId3]?materials[scope.row.insulaTypeId3].name:''}}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="insulaThick3"
                label="保温厚度3">
            </el-table-column>
            <el-table-column
                label="保温材料4">
                <template slot-scope="scope">
                    <span>{{materials[scope.row.insulaTypeId4]?materials[scope.row.insulaTypeId4].name:''}}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="insulaThick4"
                label="保温厚度4">
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="100">
                <template slot-scope="scope">
                    <el-button @click="defaultSuggestion(scope.row)" type="text" size="small" v-if="defaultSug.id!=scope.row.id">设为默认</el-button>
                    <span v-else>默认</span>
                </template>
            </el-table-column>
        </el-table>

        <div class="foot-btn">
            <el-button size="medium" type="primary" @click="addSuggestion" v-if="!updateFlag">新增</el-button>
            <el-button size="medium" type="primary" @click="updateSuggestion" v-if="!updateFlag">修改</el-button>
            <el-button size="medium" type="primary" @click="deleteSuggestion" v-if="!updateFlag&&this.suggestions.length>1">删除</el-button>
            <el-button size="medium" type="primary" @click="saveSuggestion" v-if="updateFlag">保存</el-button>
            <el-button size="medium" type="primary" @click="cancelSuggestion" v-if="updateFlag">取消</el-button>
        </div>

    </div>
</template>

<script>
export default {
    name:"overHeadParamSet",
    computed:{
        // 全局配置
        globalConfig(){
            return this.$store.state.simulation.globalConfig;
        },
        // 保温材料
        insulaMaterials(){
            return this.$store.state.simulation.globalConfig.insulaMaterialSugs;
        },
        // 保温材料对象
        materials(){
            let result={};
            let array=this.insulaMaterials;
            for(let item of array){
                let id=item.id;
                result[id]=item;
            }
            return result;
        }
    },
    data(){
        return {
            insulaData: [
                {
                    id:0,
                    name: '第一层保温',
                    insulaMaterial: {},
                    insulaThick: 0.0
                },
                {
                    id:1,
                    name: '第二层保温',
                    insulaMaterial: {},
                    insulaThick: 0.0
                },
                {
                    id:2,
                    name: '第三层保温',
                    insulaMaterial: {},
                    insulaThick: 0.0
                },
                {
                    id:3,
                    name: '第四层层保温',
                    insulaMaterial: {},
                    insulaThick: 0.0
                }
            ],  // 保温表格

            insulaTable:[], // 选中的保温表格

            insulaNumber:1, // 保温层数

            curSuggestion:{
                id:0,
                name:"默认方案",
                insulaNum:1, // 保温层数
                insulaTypeId1:1, // 保温材料1
                insulaThick1:10, // 保温厚度1
                insulaTypeId2:null, // 保温材料2
                insulaThick2:null, // 保温厚度2
                insulaTypeId3:null, // 保温材料3
                insulaThick3:null, // 保温后端3
                insulaTypeId4:null, // 保温材料4
                insulaThick4:null // 保温厚度4
            } , // 当前属性

            suggestions:[{
                id:0,
                name:"默认方案",
                insulaNum:1, // 保温层数
                insulaTypeId1:1, // 保温材料1
                insulaThick1:10, // 保温厚度1
                insulaTypeId2:null, // 保温材料2
                insulaThick2:null, // 保温厚度2
                insulaTypeId3:null, // 保温材料3
                insulaThick3:null, // 保温后端3
                insulaTypeId4:null, // 保温材料4
                insulaThick4:null // 保温厚度4
            }], // 方案列表


            defaultSug:{}, // 默认方案
            updateFlag:false, // 是否可以编辑
        }
    }
    ,
    watch:{
        // 保温层数改变
        insulaNumber(){
            this.changeInsulaNumber();
        }
    },
    mounted(){
        // 初始化数据
        this.init_data();
    },
    methods:{
        // 数据初始化
        init_data(){
            // 对保温层列表进行初始化
            let materialFirst=JSON.parse(JSON.stringify(this.insulaMaterials[0]));
            for(let item of this.insulaData){ // 将可选的保温层的每一层的材料都初始化为保温材料一
                item.insulaMaterial=materialFirst;
            }

            // // 初始化保温方案
            // if(this.globalConfig){
            //     let insulaSchemeSugs=this.globalConfig.insulaSchemeSugs;
            //     if(insulaSchemeSugs){
            //         this.suggestions=JSON.parse(JSON.stringify(insulaSchemeSugs));
            //     }
            //     let insulaSet=this.globalConfig.insulaSet;
            //     if(insulaSet){
            //         this.curSuggestion=JSON.parse(JSON.stringify(insulaSet));
            //         this.insulaNumber=insulaSet.insulaNumber;
            //     }
            // }

            // 修改保温层数
            this.changeInsulaNumber();
        }, 
        // 改变保温层数
        changeInsulaNumber(){
            // 先对数据进行深拷贝
            let curSuggestion=this.curSuggestion?this.curSuggestion:{};
            let insulaScheme=curSuggestion.insulaScheme;
            let res=[];
            let ins=parseInt(this.insulaNumber);
            for(let i=0;i<ins;i++){
                let item=null;
                // 如果属性中包含了相关的设置，则使用属性中的设置，否在使用新的设置
                if(insulaScheme&&insulaScheme[i]){ 
                    item=JSON.parse(JSON.stringify(insulaScheme[i])); // 避免修改底层数据属性
                }else{
                    item=JSON.parse(JSON.stringify(this.insulaData[i]));
                }
                res.push(item);
            }
            this.insulaTable=res;
        },
          // 新增
        addSuggestion(){
            let suglength=this.suggestions.length;
            let id=this.suggestions[suglength-1].id+1;
            this.curSuggestion={
                id:id,
                insulaNum:1, // 保温层数
                insulaTypeId1:1, // 保温材料1
                insulaThick1:10, // 保温厚度1
                insulaTypeId2:null, // 保温材料2
                insulaThick2:null, // 保温厚度2
                insulaTypeId3:null, // 保温材料3
                insulaThick3:null, // 保温后端3
                insulaTypeId4:null, // 保温材料4
                insulaThick4:null // 保温厚度4
            }
            this.updateFlag=true;
        },
        // 更新
        updateSuggestion(){
            this.updateFlag=true;
        },
        // 取消保存
        cancelSuggestion(){
            let currentId=this.curSuggestion.id;
            let temp=_find(this.suggestions, function(o) { return o.id == currentId; });
            if(!temp){
                temp=this.suggestions[0];
            }
            this.curSuggestion=JSON.parse(JSON.stringify(temp));
            this.updateFlag=false;
        },

        // 保存方案
        saveSuggestion(){
            let temp=null;
            this.suggestions.forEach((item,index)=>{
                if(item.id == this.curSuggestion.id){
                    item=JSON.parse(JSON.stringify(this.curSuggestion));
                    temp=item;
                    this.$set(this.suggestions,index,item); // 更新表格
                }
            });
            // 如果存在该类型的材料，则更新，否则新增
            if(!temp){
                temp=JSON.parse(JSON.stringify(this.curSuggestion));
                this.suggestions.push(temp);
            }
            // 关闭修改
            this.updateFlag=false;

            // 设置选中
            this.$refs.suggestionsTable.setCurrentRow(temp);

            // 触发父元素数组更新
            this.globalSuggestionChange();
            // 弹出提示框，提示保存成功
            this.$message({
                message:"保存成功",
                type:"success",
                duration:2000
            });
        },
        // 方案选中改变
        suggestionChange(item){
            item=item||this.suggestions[0];
            this.curSuggestion=JSON.parse(JSON.stringify(item));
        },
        // 删除方案
        deleteSuggestion(){
            let id=this.curSuggestion.id;
            this.suggestions=_remove(this.suggestions, function(it) {  return it.id!=id;});
            // 恢复默认
            this.curSuggestion=JSON.parse(JSON.stringify(this.suggestions[0]));
            // 设置选中
            this.$refs.suggestionsTable.setCurrentRow(this.suggestions[0]);
            // 停止更新
            this.updateFlag=false;
        },
        // 设为默认方案
        defaultSuggestion(item){
            let temp=JSON.parse(JSON.stringify(this.globalConfig));
            this.defaultSug=item;
            temp.insulaSet=item;
            this.$store.commit("simulation/setGlobalConfig",temp);
            // 后台保存用户配置
            this.$store.dispatch("simulation/saveGlobalConfig",temp);
        },
        // 全局方案修改
        globalSuggestionChange(){
            let temp=JSON.parse(JSON.stringify(this.globalConfig));
            temp.insulaSchemeSugs=this.suggestions;
            this.$store.commit("simulation/setGlobalConfig",temp);
            // 后台保存用户配置
            this.$store.dispatch("simulation/saveGlobalConfig",temp);
        }
    }
}
</script>

<style lang="scss" scoped>
.insulaSchemeSet{
    width: 700px!important;

    .attr_common{
        display: flex;
        flex-wrap: wrap;

        ::v-deep .el-form-item{
            width: 50%;
            margin-right: 0;

            .el-input{
                width: 150px;
            }
        }
    }

    .foot-btn{
        margin-top: 10px;
    }

    /** 表格 */
    .insula-table{
        margin-bottom: 10px;

        .el-table__header th{
            text-align: center;
            background: cornflowerblue;
            color:#fff;
        }

        .insula-cell{
            text-align: center;
            /** 保温厚度 */
            .thickness{
                width: 50%;
            }

            .attr_unit{
                margin-left: 5px;
            }
        }
    }
}
</style>